var _polygon, _path, _path2, _path3, _line, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: 15,
    viewBox: "0 0 50 50",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "  15,20 5,20 5,32 13,32 13,24 15,22 ",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "  M49,44.646c-0.494,0.174-1.091,0.296-1.846,0.296c-1.538,0-3.902-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71  s-3.901-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71s-3.901-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71  s-3.901-0.42-5.538-1.71c-1.637,1.29-4.001,1.71-5.539,1.71c-0.69,0-1.291-0.062-1.846-0.147",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "  M49,48.646c-0.494,0.174-1.091,0.296-1.846,0.296c-1.538,0-3.902-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71  s-3.901-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71s-3.901-0.42-5.539-1.71c-1.637,1.29-4,1.71-5.538,1.71  s-3.901-0.42-5.538-1.71c-1.637,1.29-4.001,1.71-5.539,1.71c-0.69,0-1.291-0.062-1.846-0.147",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "  M36,45c5.361,0,13-11.463,13-18.5c0-1-0.333-1.5-1.333-1.5H38c-1.209,0-1.902,0.27-2.408,0.69C34.613,26.507,33.135,32,29,32  c-3.692,0-25,0-26,0s-2,1-2,1.924v2.956c0,1.603,2.018,4.964,5.294,6.74",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.0021
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 10,
    x2: 10,
    y1: 19,
    y2: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43,31.05c0,0.919-0.919,0.95-0.919,0.95h-2.015c0,0-1.066-0.06-1.066-0.979c0-0.535,0-1.306,0-1.306  s0.034-0.386,0.653-0.386c0.62,0,0.68,0.386,0.68,0.386v0.8c0,0,0.062,0.387,0.653,0.387s0.681-0.387,0.681-0.387v-0.8  c0,0,0.062-0.386,0.682-0.386c0.621,0,0.651,0.386,0.651,0.386S43,30.546,43,31.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.06d2e0032044834579ebbc4f9c01e5e7.svg";
export { ForwardRef as ReactComponent };